import * as React from "react";
import { usePayPalScriptReducer, DISPATCH_ACTION, PayPalButtons } from "@paypal/react-paypal-js";
import { Loader } from "@grandvisionhq/common";
import { Intent } from "../../../../../../../../models/paypal/models/paypal/context.js";
import { usePaypalClientConfiguration } from "../../../../../../../../context/Paypal/context/Paypal/PaypalClientConfigurationContext.js";
const PaypalActionButton = ({
  orderType,
  events,
  isDisabled,
  layout = "horizontal"
}) => {
  const [{ isPending, options }, dispatch] = usePayPalScriptReducer();
  const paypalConfig = usePaypalClientConfiguration();
  React.useEffect(() => {
    if (dispatch && orderType === "subscription") {
      dispatch({
        type: DISPATCH_ACTION.RESET_OPTIONS,
        value: {
          ...options,
          intent: Intent.TOKENIZE,
          vault: true
        }
      });
    }
  }, [orderType]);
  const paypalButtonStyle = React.useMemo(
    () => ({
      label: "paypal",
      layout,
      tagline: false,
      shape: paypalConfig?.buttonShape || "rect",
      disableMaxWidth: true,
      ...paypalConfig?.buttonShape === "rect" ? { borderRadius: 6 } : {},
      height: 48
    }),
    [layout, paypalConfig?.buttonShape]
  );
  if (isPending) {
    return /* @__PURE__ */ React.createElement(Loader, null);
  }
  return /* @__PURE__ */ React.createElement(
    PayPalButtons,
    {
      className: "paypal-psp-action",
      "data-t": "paypal-with-paypal-pay-action",
      disabled: isDisabled,
      onError: events.onError || console.error,
      style: paypalButtonStyle,
      ...events
    }
  );
};
export {
  PaypalActionButton
};
//# sourceMappingURL=PaypalActionButton.js.map
